module.exports = __webpack_public_path__ + "static/media/Mobile_-_Food-and-Wine-Banner-822x186@2x.4fc57cbd.jpg";